import React, { useEffect } from "react";
import Modal from "../ui/Modal";
import Form, { FormField } from "../ui/Form";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as categoryActions from "src/redux/slices/categorySlice";
import { toast } from "react-toastify";

interface AddCategoryModalProps {
  open: boolean;
  category?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  open,
  category = null,
  onClose,
  onSuccess,
}) => {
  const dispatch = useAppDispatch();
  const { createCategory, editCategory } = useAppSelector(
    (state) => state.category
  );
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  // ✅ Handle create success
  useEffect(() => {
    if (createCategory.data) {
      toast.success("Category created successfully");
      handleClose();
    } else if (createCategory.error) {
      toast.error(`Error: ${createCategory.error}`);
    }
  }, [createCategory]);

  // ✅ Handle edit success
  useEffect(() => {
    if (editCategory.data) {
      toast.success("Category updated successfully");
      handleClose();
    } else if (editCategory.error) {
      toast.error(`Error: ${editCategory.error}`);
    }
  }, [editCategory]);

  const handleClose = () => {
    dispatch(categoryActions.resetCreateCategory());
    dispatch(categoryActions.resetEditCategory());
    onSuccess();
  };

  const fields: FormField[] = [
    {
      label: "Category Name",
      name: "name",
      type: "text",
      placeholder: "Enter category name",
      validations: { required: true },
    },
    {
      label: "Description",
      name: "description",
      type: "text",
      placeholder: "Enter category description",
    },
  ];

  const handleSubmit = (data: Record<string, any>) => {
    if (category?._id) {
      dispatch(
        categoryActions.editCategoryRequest({
          name: data.name,
          description: data.description,
          _id: category?._id,
        })
      );
      return;
    }

    dispatch(
    categoryActions.createCategoryRequest({
      name: data.name,
      description: data.description,
    })
  );
  };

  const modalTitle = category?._id ? "Edit Category" : "Add Category";

  return (
    <Modal open={open} onClose={onClose} title={modalTitle}>
      <Form
        initialState={category as any}
        fields={fields}
        onSubmit={handleSubmit}
        onCancel={onClose}
        loading={createCategory.loading || editCategory.loading}
      />
    </Modal>
  );
};

export default AddCategoryModal;
